import { PageMeta } from "../components/PageMeta";
import { landingByLocale } from "../content";
import type { Locale } from "../content/types";
import { CameraExperienceSection } from "../sections/CameraExperienceSection";
import { CtaSection } from "../sections/CtaSection";
import { DualCameraSection } from "../sections/DualCameraSection";
import { FeatureOverviewSection } from "../sections/FeatureOverviewSection";
import { Footer } from "../sections/Footer";
import { GallerySection } from "../sections/GallerySection";
import { Header } from "../sections/Header";
import { HeroSection } from "../sections/HeroSection";
import { ProSection } from "../sections/ProSection";
import { VideoRecordingSection } from "../sections/VideoRecordingSection";

type LandingPageProps = {
  locale: Locale;
};

export function LandingPage({ locale }: LandingPageProps) {
  const content = landingByLocale[locale];

  return (
    <div className="page-shell">
      <PageMeta title={content.seo.title} description={content.seo.description} locale={locale} kind="landing" />
      <Header content={content} locale={locale} />
      <main>
        <HeroSection content={content.hero} locale={locale} />
        <FeatureOverviewSection content={content.overview} />
        <CameraExperienceSection content={content.camera} />
        <VideoRecordingSection content={content.video} />
        <DualCameraSection content={content.dual} />
        <GallerySection content={content.gallery} />
        <ProSection content={content.pro} />
        <CtaSection content={content.cta} locale={locale} />
      </main>
      <Footer content={content.footer} locale={locale} page="home" />
    </div>
  );
}
